import { CHECK_EMAIL_REQUEST_FAIL, CHECK_EMAIL_REQUEST_SUCCESS } from '../action.types';
import InitialState from '../initial.state';

export default (state = InitialState.account, action) => {
    switch (action.type) {
        case CHECK_EMAIL_REQUEST_SUCCESS:
            return { ...action.payload }
        case CHECK_EMAIL_REQUEST_FAIL:
            return state;
        default:
            return state;
    }
}



// WEBPACK FOOTER //
// ./src/redux/checkEmail/checkEmail.reducer.js